import { z } from "zod";
import { ZRoomSyncSettings } from "./projectBase.schema";
export const MAX_ML_CEILING_ROOMS_PER_RUN = 50;
export const ZMlCeilingRoomNumbers = z.array(z.string()).max(MAX_ML_CEILING_ROOMS_PER_RUN);
/** Frozen when a run starts. Optional on old run documents and queue messages. */
export const ZRoomSyncPlan = z.object({
    version: z.literal(1),
    mcbimRooms: z.literal(true),
    mcbimItemsSnapshot: z.literal(true),
    jobs: ZRoomSyncSettings,
    /** These old job names were accepted but did not execute any work. */
    legacyNoopJobs: z.array(z.literal("addIfcInfo")).default([]),
});
